import { Controller } from "@hotwired/stimulus"

// Highlights the parent cell with a red background when the input value is blank
export default class extends Controller {
  connect() {
    this.updateBackground()
  }

  updateBackground() {
    const value = this.element.value
    const cell = this.element.closest("td")

    if (cell) {
      if (value === null || value === undefined || value.trim() === "") {
        cell.classList.add("bg-red-100")
        cell.classList.remove("bg-white")
      } else {
        cell.classList.remove("bg-red-100")
        cell.classList.add("bg-white")
      }
    }
  }

  changed() {
    this.updateBackground()
  }
}
